import React from 'react'

import { FileInput } from './styled'
import { OnUpdateParam, usePhotoUpload } from './util'

type Props = {
  onUpdate: (update: OnUpdateParam) => void
  uid: string
}

const PhotoPicker: React.FC<Props> = React.memo(({ onUpdate, uid }) => {
  const { handlePhotoInput } = usePhotoUpload(onUpdate, uid)
  return (
    <FileInput
      accept=".jpg, .jpeg, .png, .gif"
      onChange={handlePhotoInput}
      type="file"
    />
  )
})

export default PhotoPicker
